import { http } from '@/utils/http';

const baseUrl = 'vote/2020project/2020twosessions/controller2.php?enews=';

export const fetchBaseInfo = () => {
  return http.get(`${baseUrl}base-info`);
};

export const fetchLeader = () => {
  return http.get(`${baseUrl}leader`);
};

export const fetchTopics = () => {
  return http.get(`${baseUrl}topics`);
};

export const fetchNews = () => {
  return http.get(`${baseUrl}document`);
};
